import script from "./Step5Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Step5Privacy.vue?vue&type=script&setup=true&lang=js"

import "./Step5Privacy.vue?vue&type=style&index=0&id=7ab7e834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab7e834"]])

export default __exports__